<script setup>
import {onMounted, ref} from "vue";
import RequestItem from "../dashboard/RequestItem.vue";

const props = defineProps({
    notification: Object,
})
const emit = defineEmits(['close']);
const reservationChange = ref();
onMounted(() => {
    axios.get(`/app/reservations/c/${props.notification?.data.change_request}`).then((data) => reservationChange.value = data.data);
})
</script>

<template>
    <request-item v-if="reservationChange" :request="reservationChange" borderless @close="emit('close')"></request-item>
</template>

<style scoped lang="scss">

</style>
